/* Torris storefront — cache bust: 20260826-cart-11 */
if (typeof gsap !== "undefined" && typeof ScrollTrigger !== "undefined") {
  gsap.registerPlugin(ScrollTrigger);
}

let lenisInstance = null;

const brandTitle = document.querySelector(".brand-title");
const envelopeActor = document.querySelector(".envelope-actor");
const envelopeFrames = gsap.utils.toArray(".envelope-frame");
const shopStage = document.querySelector(".shop-stage");
const productCards = gsap.utils.toArray(".product-card");
const scrollHint = document.querySelector(".scroll-hint");
const floor = document.querySelector(".scroll-story__floor");

/* The scroll story only exists on the home page; every other template skips it. */
const hasStory = Boolean(
  brandTitle && envelopeActor && shopStage && envelopeFrames.length
);

if (hasStory && "scrollRestoration" in history) {
  history.scrollRestoration = "manual";
}

if (hasStory) {
  window.scrollTo(0, 0);
}

const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
const LAST_FRAME = envelopeFrames.length - 1;
let packCache = [];

function getStoryMotion() {
  const w = window.innerWidth;

  if (w <= 480) {
    return { dropY: "12vh", dropScale: 0.42, fadeY: "20vh", fadeScale: 0.3 };
  }
  if (w <= 768) {
    return { dropY: "14vh", dropScale: 0.48, fadeY: "24vh", fadeScale: 0.32 };
  }
  if (w <= 1024) {
    return { dropY: "16vh", dropScale: 0.54, fadeY: "28vh", fadeScale: 0.34 };
  }
  return { dropY: "18vh", dropScale: 0.58, fadeY: "30vh", fadeScale: 0.36 };
}

function getEnvelopeMouth() {
  const env = envelopeActor.getBoundingClientRect();
  return {
    x: env.left + env.width / 2,
    y: env.top + env.height * 0.14,
  };
}

/**
 * Smooth crossfade between adjacent frames (feels like tear/open, not image swap)
 * progress: 0 → LAST_FRAME (can be fractional)
 */
function setEnvelopeProgress(progress) {
  const max = LAST_FRAME;
  const p = Math.max(0, Math.min(max, progress));

  if (p >= max) {
    envelopeFrames.forEach((frame, n) => {
      gsap.set(frame, { opacity: n === max ? 1 : 0 });
    });
    return;
  }

  const i = Math.floor(p);
  const t = p - i;

  envelopeFrames.forEach((frame, n) => {
    let opacity = 0;
    if (n === i) opacity = 1 - t;
    else if (n === i + 1) opacity = t;
    gsap.set(frame, { opacity });
  });
}

function textTravelY() {
  const titleBox = brandTitle.getBoundingClientRect();
  const envBox = envelopeActor.getBoundingClientRect();
  return envBox.top + envBox.height * 0.3 - titleBox.top - titleBox.height * 0.5;
}

function packProductsInEnvelope() {
  gsap.set(shopStage, { autoAlpha: 1, visibility: "visible" });

  const mouth = getEnvelopeMouth();
  if (!mouth.x) return;

  productCards.forEach((card) => {
    gsap.set(card, {
      x: 0,
      y: 0,
      scale: 1,
      autoAlpha: 0,
      visibility: "visible",
    });
  });

  productCards.forEach((card) => {
    const box = card.getBoundingClientRect();
    const cx = box.left + box.width / 2;
    const cy = box.top + box.height / 2;
    gsap.set(card, {
      x: mouth.x - cx,
      y: mouth.y - cy,
      scale: 0.06,
      autoAlpha: 0,
      transformOrigin: "50% 50%",
    });
  });
}

function setupLenis() {
  if (reduced || typeof Lenis === "undefined") return null;

  const lenis = new Lenis({ duration: 1.15, smoothWheel: true });

  lenis.on("scroll", ScrollTrigger.update);

  ScrollTrigger.scrollerProxy(document.documentElement, {
    scrollTop(value) {
      if (arguments.length) {
        lenis.scrollTo(value, { immediate: true });
      }
      return lenis.scroll;
    },
    getBoundingClientRect() {
      return {
        top: 0,
        left: 0,
        width: window.innerWidth,
        height: window.innerHeight,
      };
    },
  });

  ScrollTrigger.addEventListener("refresh", () => lenis.resize());

  gsap.ticker.add((time) => lenis.raf(time * 1000));
  gsap.ticker.lagSmoothing(0);
  return lenis;
}

function preloadImage(img, timeoutMs = 4000) {
  return new Promise((resolve) => {
    if (!img) return resolve();

    if (img.complete) return resolve();

    let done = false;
    const finish = () => {
      if (done) return;
      done = true;
      resolve();
    };

    img.addEventListener("load", finish, { once: true });
    img.addEventListener("error", finish, { once: true });
    window.setTimeout(finish, timeoutMs);
  });
}

function preloadFrameImages() {
  return Promise.all(envelopeFrames.map((img) => preloadImage(img)));
}

function preloadProductImages() {
  const imgs = document.querySelectorAll(".product-card__media img");
  return Promise.all(Array.from(imgs).map((img) => preloadImage(img)));
}

function computePack() {
  gsap.set(shopStage, { autoAlpha: 1, visibility: "visible" });
  shopStage.classList.add("is-active");

  productCards.forEach((card) => {
    gsap.set(card, {
      x: 0,
      y: 0,
      scale: 1,
      autoAlpha: 0,
      visibility: "visible",
    });
  });

  void shopStage.offsetHeight;

  const mouth = getEnvelopeMouth();

  return productCards.map((card) => {
    const box = card.getBoundingClientRect();
    return {
      x: mouth.x - (box.left + box.width / 2),
      y: mouth.y - (box.top + box.height / 2),
    };
  });
}

function applyBurst(t) {
  const p = Math.max(0, Math.min(1, t));

  if (p > 0.05) {
    gsap.set(shopStage, { autoAlpha: 1, visibility: "visible" });
    enableProductInteraction();
  }

  productCards.forEach((card, i) => {
    const from = packCache[i] || { x: 0, y: 0 };
    gsap.set(card, {
      x: from.x * (1 - p),
      y: from.y * (1 - p),
      scale: 0.06 + 0.94 * p,
      autoAlpha: p,
      visibility: "visible",
    });
  });
}

const siteHeader = document.querySelector(".site-header");

function setHeaderStuck(stuck) {
  siteHeader?.classList.toggle("is-stuck", stuck);
}

function enableProductInteraction() {
  shopStage?.classList.add("is-active");
}

function disableProductInteraction() {
  shopStage?.classList.remove("is-active");
}

function resetStoryVisualState() {
  packCache = [];
  disableProductInteraction();
  gsap.set(envelopeActor, {
    autoAlpha: 1,
    scale: 1,
    y: 0,
    zIndex: 30,
  });
  packProductsInEnvelope();
}

function initStory() {
  if (!hasStory) return;

  packCache = [];

  /* ===== FIRST SCREEN ===== */
  setEnvelopeProgress(0);
  gsap.set(brandTitle, { autoAlpha: 1, y: 0, scale: 1 });
  gsap.set(envelopeActor, {
    transformOrigin: "50% 20%",
    autoAlpha: 1,
    scale: 1,
    y: 0,
  });
  gsap.set(shopStage, { autoAlpha: 1, visibility: "visible" });
  gsap.set(productCards, { autoAlpha: 0, visibility: "visible" });
  if (scrollHint) gsap.set(scrollHint, { autoAlpha: 0.55 });
  if (floor) gsap.set(floor, { opacity: 0.85 });
  shopStage?.classList.remove("is-active");

  if (reduced) {
    gsap.set(brandTitle, { autoAlpha: 0 });
    gsap.set(envelopeActor, { autoAlpha: 0 });
    if (scrollHint) gsap.set(scrollHint, { autoAlpha: 0 });
    gsap.set(productCards, { clearProps: "all", autoAlpha: 1, visibility: "visible" });
    setEnvelopeProgress(LAST_FRAME);
    shopStage.classList.add("is-active");
    setHeaderStuck(true);
    return;
  }

  packProductsInEnvelope();

  const openState = { frame: 0 };
  const burst = { t: 0 };
  const REVEAL_START = 0.82;

  function ensurePackCache() {
    if (!packCache.length) {
      packCache = computePack();
    }
  }

  const tl = gsap.timeline({
    defaults: { ease: "none" },
    scrollTrigger: {
      trigger: ".scroll-story",
      start: "top top",
      end: "bottom bottom",
      scrub: 0.85,
      pin: ".scroll-story__pin",
      anticipatePin: 1,
      invalidateOnRefresh: true,
      onUpdate: (self) => {
        if (self.progress >= 0.82) {
          enableProductInteraction();
          setHeaderStuck(true);
        } else if (self.progress < 0.75) {
          disableProductInteraction();
          setHeaderStuck(false);
        }
      },
      onRefresh: (self) => {
        if (self.progress >= 0.9) {
          enableProductInteraction();
        } else if (self.progress < 0.78) {
          resetStoryVisualState();
        } else if (burst.t > 0) {
          packCache = [];
          ensurePackCache();
          applyBurst(burst.t);
        } else {
          packProductsInEnvelope();
        }
      },
    },
  });

  /* —— 0. Hold first screen —— */
  if (floor) tl.to(floor, { opacity: 1, duration: 0.04 }, 0);
  tl.to({}, { duration: 0.16 }, 0);

  /* —— 1. Text goes down —— */
  if (scrollHint) tl.to(scrollHint, { autoAlpha: 0, duration: 0.06 }, 0.16);
  tl.to(
    brandTitle,
    {
      y: () => textTravelY(),
      scale: 0.7,
      duration: 0.18,
      ease: "power1.in",
    },
    0.18
  ).to(brandTitle, { autoAlpha: 0, duration: 0.08, ease: "power1.in" }, 0.32);

  /* —— 2. Envelope opens —— */
  tl.to(
    openState,
    {
      frame: LAST_FRAME,
      duration: 0.32,
      ease: "none",
      onUpdate: () => setEnvelopeProgress(openState.frame),
    },
    0.42
  );

  /* Hold fully open envelope before reveal scroll —— */
  tl.to({}, { duration: 0.08 }, 0.74);

  /* —— 3. One scroll: envelope down + fade, products burst —— */
  tl.set(envelopeActor, { zIndex: 4 }, REVEAL_START);

  tl.to(
    envelopeActor,
    {
      y: () => getStoryMotion().fadeY,
      scale: () => getStoryMotion().fadeScale,
      autoAlpha: 0,
      duration: 0.34,
      ease: "power2.inOut",
    },
    REVEAL_START
  );

  tl.to(
    burst,
    {
      t: 1,
      duration: 0.3,
      ease: "power2.out",
      onStart: () => {
        packCache = [];
        ensurePackCache();
        applyBurst(0);
      },
      onUpdate: () => applyBurst(burst.t),
      onComplete: enableProductInteraction,
      onReverseComplete: () => {
        resetStoryVisualState();
        burst.t = 0;
      },
    },
    REVEAL_START + 0.08
  );

  tl.call(enableProductInteraction, null, REVEAL_START + 0.38);
  tl.to({}, { duration: 0.1 }, REVEAL_START + 0.38);
}

/* Once the hero is fully behind us the header always stays solid. */
function initStickyHeader() {
  const storyHero = document.querySelector(".scroll-story");
  const imageHero = document.querySelector(".hero-slider");

  if (!siteHeader) return;

  if (storyHero) {
    ScrollTrigger.create({
      trigger: storyHero,
      start: "bottom bottom",
      end: "max",
      onEnter: () => setHeaderStuck(true),
    });
    return;
  }

  if (imageHero) {
    const sync = () => {
      const past = imageHero.getBoundingClientRect().bottom <= siteHeader.offsetHeight + 8;
      setHeaderStuck(past);
    };
    sync();
    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    return;
  }

  setHeaderStuck(true);
}

window.addEventListener("load", async () => {
  if (hasStory) {
    window.scrollTo(0, 0);
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    await Promise.all([preloadFrameImages(), preloadProductImages()]);

    gsap.set(envelopeFrames[0], { opacity: 1 });
    envelopeFrames.slice(1).forEach((f) => gsap.set(f, { opacity: 0 }));
  }

  ScrollTrigger.getAll().forEach((trigger) => trigger.kill());

  lenisInstance = setupLenis();
  if (lenisInstance && hasStory) {
    lenisInstance.scrollTo(0, { immediate: true });
  }

  try {
    initStory();
  } catch (error) {
    console.error("Scroll story init failed:", error);
  }

  initStickyHeader();
  if (!window.__torrisCartInline) bindProductOpenTriggers();

  requestAnimationFrame(() => {
    ScrollTrigger.refresh();
    ScrollTrigger.update();
    if (!window.__torrisCartInline) bindProductOpenTriggers();
  });
});

document.addEventListener("DOMContentLoaded", () => {
  if (hasStory) window.scrollTo(0, 0);
  syncHeaderHeight();
  initHeroSlider();
  initReviewsSlider();
  initProcessSlider();
  initCatalogSlider();
  if (!window.__torrisCartInline) {
    initCatalogForms();
    initProductQuickView();
    initProductPage();
  }
  initCartPage();
  if (!window.__torrisCartInline) bindProductOpenTriggers();
});

window.addEventListener("resize", syncHeaderHeight);

window.addEventListener("pageshow", (event) => {
  if (hasStory) {
    window.scrollTo(0, 0);
    if (lenisInstance) {
      lenisInstance.scrollTo(0, { immediate: true });
    }
  }
  if (!window.__torrisCartInline) bindProductOpenTriggers();
  if (event.persisted) {
    ScrollTrigger.refresh();
    ScrollTrigger.update();
  }
});

function debounce(fn, wait) {
  let timeoutId = null;
  return (...args) => {
    window.clearTimeout(timeoutId);
    timeoutId = window.setTimeout(() => fn(...args), wait);
  };
}

window.addEventListener(
  "resize",
  debounce(() => ScrollTrigger.refresh(), 250)
);

/* —— Process slider —— */
function initProcessSlider() {
  const viewport = document.querySelector(".process-slider__viewport");
  if (!viewport || viewport.dataset.ready === "true") return;
  viewport.dataset.ready = "true";

  const track = viewport.querySelector(".process-slider__track");
  const slides = Array.from(viewport.querySelectorAll(".process-slide"));
  const prevBtn = viewport.querySelector(".process-slider__nav--prev");
  const nextBtn = viewport.querySelector(".process-slider__nav--next");
  const currentEl = viewport.querySelector(".process-slider__current");
  const totalEl = viewport.querySelector(".process-slider__total");
  const AUTOPLAY_MS = 4500;
  const START_INDEX = 0;
  let index = START_INDEX;
  let autoplayId = null;
  let slideWidth = 0;

  if (!track || !slides.length) return;

  if (totalEl) totalEl.textContent = String(slides.length).padStart(2, "0");

  function measure() {
    slideWidth = viewport.clientWidth;
    slides.forEach((slide) => {
      slide.style.width = `${slideWidth}px`;
      slide.style.flexBasis = `${slideWidth}px`;
    });
    track.style.width = `${slideWidth * slides.length}px`;
    applyTransform(false);
  }

  function applyTransform(animate) {
    track.style.transition = animate
      ? "transform 0.65s cubic-bezier(0.22, 1, 0.36, 1)"
      : "none";
    track.style.transform = `translate3d(${-index * slideWidth}px, 0, 0)`;

    slides.forEach((slide, i) => slide.classList.toggle("is-active", i === index));
    if (currentEl) currentEl.textContent = String(index + 1).padStart(2, "0");
  }

  function goTo(next, animate = true) {
    index = (next + slides.length) % slides.length;
    applyTransform(animate);
  }

  function startAutoplay() {
    if (slides.length <= 1 || reduced) return;
    stopAutoplay();
    autoplayId = window.setInterval(() => goTo(index + 1), AUTOPLAY_MS);
  }

  function stopAutoplay() {
    if (autoplayId) {
      window.clearInterval(autoplayId);
      autoplayId = null;
    }
  }

  prevBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    goTo(index - 1);
    startAutoplay();
  });

  nextBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    goTo(index + 1);
    startAutoplay();
  });

  viewport.addEventListener("mouseenter", stopAutoplay);
  viewport.addEventListener("mouseleave", startAutoplay);

  window.addEventListener("resize", () => {
    measure();
  });

  requestAnimationFrame(() => {
    measure();
    startAutoplay();
  });
}

/* —— Homepage hero image slider —— */
function initHeroSlider(root = document) {
  const sections = Array.from(root.querySelectorAll("[data-hero-slider]")).filter(
    (section) => section.dataset.ready !== "true"
  );

  sections.forEach((section) => {
    const track = section.querySelector("[data-hero-track]");
    const slides = Array.from(section.querySelectorAll("[data-hero-slide]"));
    const dots = Array.from(section.querySelectorAll("[data-hero-dot]"));
    const prevBtn = section.querySelector("[data-hero-prev]");
    const nextBtn = section.querySelector("[data-hero-next]");
    if (!track || slides.length < 1) return;

    section.dataset.ready = "true";
    let index = 0;
    let timer = null;
    const autoplay = Math.max(3000, Number(section.dataset.autoplay) || 5000);
    section.style.setProperty("--hero-autoplay", `${autoplay}ms`);

    function slideOffset() {
      const width = section.querySelector("[data-hero-viewport]")?.clientWidth || section.clientWidth || window.innerWidth;
      return index * width;
    }

    function goTo(next, restart = true) {
      index = ((next % slides.length) + slides.length) % slides.length;
      track.style.transform = `translate3d(${-slideOffset()}px, 0, 0)`;
      slides.forEach((slide, i) => {
        const on = i === index;
        slide.classList.toggle("is-active", on);
        slide.setAttribute("aria-hidden", on ? "false" : "true");
      });
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
        const progress = dot.querySelector(".hero-slider__dot-progress");
        if (progress) {
          progress.style.animation = "none";
          void progress.offsetWidth;
          progress.style.animation = "";
        }
      });
      if (restart) start();
    }

    window.addEventListener("resize", () => {
      track.style.transition = "none";
      track.style.transform = `translate3d(${-slideOffset()}px, 0, 0)`;
      requestAnimationFrame(() => {
        track.style.transition = "";
      });
    });

    function start() {
      stop();
      if (slides.length < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      timer = window.setInterval(() => goTo(index + 1), autoplay);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    prevBtn?.addEventListener("click", () => goTo(index - 1));
    nextBtn?.addEventListener("click", () => goTo(index + 1));
    dots.forEach((dot) => {
      dot.addEventListener("click", () => goTo(Number(dot.dataset.heroDot) || 0));
    });

    section.addEventListener("mouseenter", () => {
      section.classList.add("is-paused");
      stop();
    });
    section.addEventListener("mouseleave", () => {
      section.classList.remove("is-paused");
      start();
    });
    section.addEventListener("focusin", () => {
      section.classList.add("is-paused");
      stop();
    });
    section.addEventListener("focusout", (event) => {
      if (section.contains(event.relatedTarget)) return;
      section.classList.remove("is-paused");
      start();
    });

    let touchX = null;
    section.addEventListener(
      "touchstart",
      (event) => {
        touchX = event.changedTouches[0]?.clientX ?? null;
        stop();
      },
      { passive: true }
    );
    section.addEventListener(
      "touchend",
      (event) => {
        if (touchX == null) return;
        const delta = (event.changedTouches[0]?.clientX ?? touchX) - touchX;
        touchX = null;
        if (Math.abs(delta) > 40) goTo(index + (delta < 0 ? 1 : -1));
        else start();
      },
      { passive: true }
    );

    goTo(0);
  });
}

/* —— Reviews slider (multi-card pages + dots) —— */
function initReviewsSlider(root = document) {
  const sections = Array.from(root.querySelectorAll("[data-reviews]")).filter(
    (section) => section.dataset.ready !== "true"
  );

  sections.forEach((section) => {
    const track = section.querySelector("[data-reviews-track]");
    const viewport = section.querySelector("[data-reviews-viewport]");
    const dotsWrap = section.querySelector("[data-reviews-dots]");
    const slides = Array.from(section.querySelectorAll("[data-reviews-slide]"));
    if (!track || !viewport || slides.length < 1) return;

    section.dataset.ready = "true";
    let index = 0;
    let timer = null;
    let dots = [];
    const autoplay = Math.max(4000, Number(section.dataset.autoplay) || 6000);

    function perView() {
      const raw = getComputedStyle(section).getPropertyValue("--reviews-per-view").trim();
      const n = Number(raw);
      return Number.isFinite(n) && n > 0 ? n : 1;
    }

    function pageCount() {
      return Math.max(1, Math.ceil(slides.length / perView()));
    }

    function buildDots() {
      if (!dotsWrap) return;
      const pages = pageCount();
      dotsWrap.innerHTML = "";
      dots = [];
      if (pages < 2) return;
      for (let i = 0; i < pages; i += 1) {
        const dot = document.createElement("button");
        dot.type = "button";
        dot.className = "reviews__dot";
        dot.dataset.reviewsDot = String(i);
        dot.setAttribute("role", "tab");
        dot.setAttribute("aria-label", `Go to reviews page ${i + 1}`);
        dot.addEventListener("click", () => goTo(i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function offset() {
      return index * viewport.clientWidth;
    }

    function goTo(next, restart = true) {
      const pages = pageCount();
      index = ((next % pages) + pages) % pages;
      track.style.transform = `translate3d(${-offset()}px, 0, 0)`;
      const start = index * perView();
      const end = start + perView();
      slides.forEach((slide, i) => {
        const on = i >= start && i < end;
        slide.classList.toggle("is-active", on);
        slide.setAttribute("aria-hidden", on ? "false" : "true");
      });
      dots.forEach((dot, i) => {
        const on = i === index;
        dot.classList.toggle("is-active", on);
        dot.setAttribute("aria-selected", on ? "true" : "false");
      });
      if (restart) startAuto();
    }

    function startAuto() {
      stop();
      if (pageCount() < 2 || window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
      timer = window.setInterval(() => goTo(index + 1), autoplay);
    }

    function stop() {
      if (timer) window.clearInterval(timer);
      timer = null;
    }

    section.addEventListener("mouseenter", stop);
    section.addEventListener("mouseleave", startAuto);
    window.addEventListener("resize", () => {
      buildDots();
      if (index >= pageCount()) index = 0;
      track.style.transition = "none";
      track.style.transform = `translate3d(${-offset()}px, 0, 0)`;
      requestAnimationFrame(() => {
        track.style.transition = "";
        goTo(index, false);
      });
    });

    /* Touch / pointer swipe — continuous forward & back */
    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let dragX = 0;
    let dragging = false;
    let locked = null;

    function onPointerDown(event) {
      if (pageCount() < 2) return;
      if (event.pointerType === "mouse" && event.button !== 0) return;
      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      dragX = 0;
      dragging = true;
      locked = null;
      stop();
      track.style.transition = "none";
      try {
        viewport.setPointerCapture(pointerId);
      } catch (_) {
        /* ignore */
      }
    }

    function onPointerMove(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      const dx = event.clientX - startX;
      const dy = event.clientY - startY;
      if (locked == null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        locked = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
      }
      if (locked !== "x") return;
      if (event.cancelable) event.preventDefault();
      dragX = dx;
      track.style.transform = `translate3d(${-(offset() - dragX)}px, 0, 0)`;
    }

    function onPointerUp(event) {
      if (!dragging || event.pointerId !== pointerId) return;
      dragging = false;
      track.style.transition = "";
      try {
        viewport.releasePointerCapture(pointerId);
      } catch (_) {
        /* ignore */
      }
      pointerId = null;
      if (locked === "x" && Math.abs(dragX) > 48) {
        goTo(index + (dragX < 0 ? 1 : -1));
      } else {
        goTo(index);
      }
      dragX = 0;
      locked = null;
    }

    viewport.addEventListener("pointerdown", onPointerDown);
    viewport.addEventListener("pointermove", onPointerMove, { passive: false });
    viewport.addEventListener("pointerup", onPointerUp);
    viewport.addEventListener("pointercancel", onPointerUp);

    buildDots();
    goTo(0);
  });
}

/* —— Catalog slider (Shopify collection grid) —— */
function syncHeaderHeight() {
  const header = document.querySelector(".site-header");
  if (!header) return;
  const height = Math.ceil(header.getBoundingClientRect().height);
  if (height > 0) {
    document.documentElement.style.setProperty("--header-h", `${height}px`);
  }
}

function initCatalogSlider() {
  const section = document.querySelector("[data-catalog-root], .catalog");
  if (!section) return;

  /* Section reorder keeps the same node — just remeasure. Fresh HTML needs a full bind. */
  if (section.dataset.ready === "true") {
    if (typeof section.__catalogMeasure === "function") section.__catalogMeasure();
    return;
  }
  section.dataset.ready = "true";

  const viewport = section.querySelector(".catalog__viewport");
  const pager = section.querySelector("[data-catalog-pager]");
  const prevBtn = section.querySelector(".catalog__nav--prev");
  const nextBtn = section.querySelector(".catalog__nav--next");
  const dotsHost = section.querySelector("[data-catalog-dots]");
  const filterLinks = Array.from(section.querySelectorAll("[data-catalog-filter], .catalog__filter-link"));
  const viewAll = section.querySelector("[data-catalog-view-all]");
  let track = section.querySelector(".catalog__track:not([hidden])") || section.querySelector(".catalog__track");
  let items = [];
  let index = 0;
  let visibleCount = 4;
  let itemWidth = 0;
  let trackGap = 0;

  if (!viewport || !track) return;

  function activeTrack() {
    return section.querySelector(".catalog__track:not([hidden])") || section.querySelector(".catalog__track");
  }

  function refreshItems() {
    track = activeTrack();
    items = track ? Array.from(track.querySelectorAll(".catalog__item, .grid__item")).filter((item) => !item.classList.contains("catalog__empty")) : [];
  }

  function isGridMode() {
    return window.innerWidth <= 1024;
  }

  function getVisibleCount() {
    const w = window.innerWidth;
    if (isGridMode()) return Math.max(items.length, 1);
    if (w < 1280) return Math.min(3, Math.max(items.length, 1));
    return Math.min(4, Math.max(items.length, 1));
  }

  function maxIndex() {
    return Math.max(0, items.length - visibleCount);
  }

  function slideOffset() {
    return index * (itemWidth + trackGap);
  }

  function applyTransform(animate) {
    if (!track) return;
    track.style.transition = animate
      ? "transform 0.55s cubic-bezier(0.22, 1, 0.36, 1)"
      : "none";
    track.style.transform = `translate3d(${-slideOffset()}px, 0, 0)`;
  }

  function renderDots() {
    if (!dotsHost) return;
    const pages = Math.max(0, maxIndex()) + 1;
    const needPager = !isGridMode() && pages > 1 && items.length > 0;

    if (pager) pager.hidden = !needPager;
    if (!needPager) {
      dotsHost.innerHTML = "";
      return;
    }

    if (dotsHost.childElementCount !== pages) {
      dotsHost.innerHTML = Array.from({ length: pages }, (_, i) => {
        return `<button type="button" class="catalog__dot" data-catalog-dot="${i}" role="tab" aria-label="Go to page ${i + 1}"></button>`;
      }).join("");
    }

    Array.from(dotsHost.children).forEach((dot, i) => {
      const on = i === index;
      dot.classList.toggle("is-active", on);
      dot.setAttribute("aria-selected", on ? "true" : "false");
    });
  }

  function updateNav() {
    const fitsOnScreen = maxIndex() === 0 || items.length === 0 || isGridMode();

    if (prevBtn) {
      prevBtn.disabled = index <= 0 || fitsOnScreen;
    }

    if (nextBtn) {
      nextBtn.disabled = index >= maxIndex() || fitsOnScreen;
    }

    renderDots();
  }

  function measure() {
    refreshItems();
    if (!track) return;
    visibleCount = getVisibleCount();

    if (isGridMode()) {
      track.style.transition = "none";
      track.style.transform = "none";
      track.style.width = "100%";
      items.forEach((item) => {
        item.style.width = "";
        item.style.flexBasis = "";
      });
      index = 0;
      updateNav();
      return;
    }

    trackGap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    itemWidth = items.length
      ? (viewport.clientWidth - trackGap * (visibleCount - 1)) / visibleCount
      : viewport.clientWidth;

    items.forEach((item) => {
      item.style.width = `${itemWidth}px`;
      item.style.flexBasis = `${itemWidth}px`;
    });

    track.style.width = items.length
      ? `${items.length * itemWidth + (items.length - 1) * trackGap}px`
      : "100%";
    index = Math.min(index, maxIndex());
    applyTransform(false);
    updateNav();
  }

  function goTo(next, animate = true) {
    index = Math.max(0, Math.min(maxIndex(), next));
    applyTransform(animate);
    updateNav();
  }

  function showPanel(panelId) {
    const panels = Array.from(section.querySelectorAll("[data-catalog-panel-track]"));
    panels.forEach((panel) => {
      const on = panel.id === panelId;
      panel.hidden = !on;
      if (!on) {
        panel.style.transform = "none";
        panel.style.width = "";
      }
    });

    const active = section.querySelector(`#${CSS.escape(panelId)}`);
    if (viewAll && active) {
      const url = active.getAttribute("data-catalog-view-url");
      if (url) viewAll.setAttribute("href", url);
    }

    index = 0;
    requestAnimationFrame(measure);
  }

  prevBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    goTo(index - 1);
  });

  nextBtn?.addEventListener("click", (event) => {
    event.preventDefault();
    goTo(index + 1);
  });

  dotsHost?.addEventListener("click", (event) => {
    const dot = event.target.closest("[data-catalog-dot]");
    if (!dot || !dotsHost.contains(dot)) return;
    event.preventDefault();
    goTo(Number(dot.getAttribute("data-catalog-dot")) || 0);
  });

  filterLinks.forEach((link) => {
    link.addEventListener("click", (event) => {
      event.preventDefault();
      const panelId = link.getAttribute("data-catalog-panel");
      if (!panelId) return;

      filterLinks.forEach((item) => {
        const on = item === link;
        item.classList.toggle("is-active", on);
        item.setAttribute("aria-pressed", on ? "true" : "false");
      });

      showPanel(panelId);
    });
  });

  window.addEventListener("resize", () => {
    measure();
  });

  section.__catalogMeasure = measure;
  requestAnimationFrame(measure);
}

function refreshCatalogAfterSectionChange(container, forceRebind) {
  const root =
    (container && container.querySelector && container.querySelector("[data-catalog-root], .catalog")) ||
    (container && container.matches && container.matches("[data-catalog-root], .catalog") && container) ||
    document.querySelector("[data-catalog-root], .catalog");

  if (root && forceRebind) {
    delete root.dataset.ready;
    root.__catalogMeasure = null;
  }

  if (root) initCatalogSlider();
  syncHeaderHeight();
}

document.addEventListener("shopify:section:load", (event) => {
  refreshCatalogAfterSectionChange(event.target, true);
  const hero = event.target.querySelector?.("[data-hero-slider]");
  if (hero) {
    delete hero.dataset.ready;
    initHeroSlider(event.target);
  } else if (event.target.matches?.("[data-hero-slider]")) {
    delete event.target.dataset.ready;
    initHeroSlider(event.target.parentElement || document);
  }

  const reviews = event.target.querySelector?.("[data-reviews]");
  if (reviews) {
    delete reviews.dataset.ready;
    initReviewsSlider(event.target);
  } else if (event.target.matches?.("[data-reviews]")) {
    delete event.target.dataset.ready;
    initReviewsSlider(event.target.parentElement || document);
  }
});

document.addEventListener("shopify:section:reorder", () => {
  refreshCatalogAfterSectionChange(document, false);
});

document.addEventListener("shopify:section:select", (event) => {
  refreshCatalogAfterSectionChange(event.target, false);
});

/* —— Product quick view —— */

/* Used when a card carries no Shopify variant data (static preview / demo store). */
const DEMO_SIZES = ["S", "M", "L", "XL"];
const DEMO_COLORS = ["Black", "Gray", "Navy"];

const COLOR_OPTION_NAMES = ["color", "colour", "colours", "colors"];
const SIZE_ORDER = ["XXS", "XS", "S", "M", "L", "XL", "XXL", "2XL", "3XL", "4XL"];

const SWATCH_HEX = {
  black: "#1a1a1a",
  white: "#f2efe9",
  ivory: "#f4efe6",
  cream: "#ebe4d8",
  beige: "#d8cbb8",
  sand: "#cbbba4",
  gray: "#9a9590",
  grey: "#9a9590",
  charcoal: "#3a3530",
  brown: "#5c4f45",
  tan: "#b99a76",
  navy: "#1e3348",
  blue: "#2f4d7a",
  "ink blue": "#1a2840",
  ink: "#1a1a1a",
  green: "#3f5f4a",
  olive: "#5a5f47",
  red: "#8c2f2a",
  burgundy: "#5e2230",
  pink: "#d9b3b3",
  yellow: "#d9bc63",
  orange: "#c2703d",
  purple: "#5b4570",
};

function parseJsonAttribute(value) {
  if (!value) return null;
  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
}

function normOptionValue(value) {
  return String(value ?? "").trim();
}

function normalizeVariant(variant) {
  return {
    ...variant,
    id: String(variant?.id ?? ""),
    price: variant?.price || "",
    price_raw: Number(variant?.price_raw ?? 0),
    compare_at_price: variant?.compare_at_price || null,
    compare_at_price_raw: Number(variant?.compare_at_price_raw ?? 0),
    options: (variant?.options || []).map(normOptionValue),
    available: variant?.available !== false,
  };
}

function isSizeOption(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .includes("size");
}

function sortOptionValues(name, values) {
  if (!isSizeOption(name)) return values;

  return [...values].sort((a, b) => {
    const aKey = normOptionValue(a).toUpperCase();
    const bKey = normOptionValue(b).toUpperCase();
    const aIndex = SIZE_ORDER.indexOf(aKey);
    const bIndex = SIZE_ORDER.indexOf(bKey);

    if (aIndex === -1 && bIndex === -1) return aKey.localeCompare(bKey);
    if (aIndex === -1) return 1;
    if (bIndex === -1) return -1;
    return aIndex - bIndex;
  });
}

function variantDiscountPercent(variant) {
  const compare = variant?.compare_at_price_raw || 0;
  const price = variant?.price_raw || 0;
  if (!compare || compare <= price) return null;
  return Math.round(((compare - price) / compare) * 100);
}

function shouldShowOption(option) {
  return !(option.values.length === 1 && normOptionValue(option.values[0]) === "Default Title");
}

function buildDemoProduct(card) {
  const baseId = Number(card.dataset.variantId || 0);
  const price = card.dataset.productPrice || "";
  const comparePrice = card.dataset.productComparePrice || null;
  const variants = [];
  let offset = 0;

  DEMO_SIZES.forEach((size) => {
    DEMO_COLORS.forEach((color) => {
      variants.push(
        normalizeVariant({
          id: String(baseId + offset),
          available: true,
          price,
          compare_at_price: comparePrice,
          options: [size, color],
        })
      );
      offset += 1;
    });
  });

  return {
    options: [
      { name: "Size", position: 1, values: DEMO_SIZES },
      { name: "Color", position: 2, values: DEMO_COLORS },
    ],
    variants,
    images: {
      primary: card.dataset.productImage || "",
      secondary: null,
    },
  };
}

function readProductData(card) {
  const script = card.querySelector("[data-product-json]");
  if (script) {
    try {
      const data = JSON.parse(script.textContent.trim());
      if (Array.isArray(data.options) && data.options.length && Array.isArray(data.variants) && data.variants.length) {
        return {
          options: data.options.map((option) => ({
            ...option,
            values: (option.values || []).map(normOptionValue),
          })),
          variants: data.variants.map(normalizeVariant),
          images: {
            primary: data.featured_image || card.dataset.productImage || "",
            secondary: data.secondary_image || null,
          },
        };
      }
    } catch (error) {
      console.warn("Product JSON parse failed:", error);
    }
  }

  const options = parseJsonAttribute(card.getAttribute("data-product-options"));
  const variants = parseJsonAttribute(card.getAttribute("data-product-variants"));

  if (Array.isArray(options) && options.length && Array.isArray(variants) && variants.length) {
    return {
      options: options.map((option) => ({
        ...option,
        values: (option.values || []).map(normOptionValue),
      })),
      variants: variants.map(normalizeVariant),
      images: {
        primary: card.dataset.productImage || "",
        secondary: null,
      },
    };
  }

  if (document.body?.dataset.shopifyTheme === "true") {
    const fallbackId = card.dataset.variantId || "";
    return {
      options: [],
      variants: fallbackId
        ? [
            normalizeVariant({
              id: fallbackId,
              available: true,
              price: card.dataset.productPrice || "",
              options: [],
            }),
          ]
        : [],
      images: {
        primary: card.dataset.productImage || "",
        secondary: null,
      },
    };
  }

  return buildDemoProduct(card);
}

function renderModalPrice(el, variant, fallback) {
  if (!el) return;

  el.innerHTML = "";

  if (!variant?.price) {
    el.textContent = fallback;
    return;
  }

  if (variant.compare_at_price) {
    const compare = document.createElement("s");
    compare.className = "product-modal__price-compare";
    compare.textContent = variant.compare_at_price;

    const current = document.createElement("span");
    current.className = "product-modal__price-current";
    current.textContent = variant.price;

    el.appendChild(compare);
    el.appendChild(document.createTextNode(" "));
    el.appendChild(current);
    return;
  }

  el.textContent = variant.price;
}

function setModalImages({ primary, secondary, alt, variantImage }) {
  const primaryEl = document.getElementById("ProductModalImage");
  const altEl = document.getElementById("ProductModalImageAlt");
  const wrap = document.getElementById("ProductModalHoverImages");

  if (!primaryEl) return;

  const mainImage = variantImage || primary || "";
  primaryEl.src = mainImage;
  primaryEl.alt = alt || "";

  const hoverImage = secondary && secondary !== mainImage ? secondary : "";

  if (altEl && hoverImage) {
    altEl.src = hoverImage;
    altEl.hidden = false;
    wrap?.classList.add("product-hover-images--swap");
  } else {
    if (altEl) {
      altEl.removeAttribute("src");
      altEl.hidden = true;
    }
    wrap?.classList.remove("product-hover-images--swap");
  }
}

function isColorOption(name) {
  return COLOR_OPTION_NAMES.includes(String(name || "").trim().toLowerCase());
}

function hashToSwatchColor(value) {
  let hash = 0;
  for (let i = 0; i < value.length; i += 1) {
    hash = value.charCodeAt(i) + ((hash << 5) - hash);
  }
  const hue = Math.abs(hash) % 360;
  return `hsl(${hue}, 38%, 32%)`;
}

function swatchColor(value) {
  const raw = String(value || "").trim();
  if (!raw) return "#9a9590";

  if (/^#([0-9a-f]{3}|[0-9a-f]{6}|[0-9a-f]{8})$/i.test(raw)) return raw;

  const key = raw.toLowerCase();
  if (SWATCH_HEX[key]) return SWATCH_HEX[key];

  const tokens = key.split(/[\s\-/]+/).filter(Boolean);
  for (const token of tokens) {
    if (SWATCH_HEX[token]) return SWATCH_HEX[token];
  }

  const sortedNames = Object.keys(SWATCH_HEX).sort((a, b) => b.length - a.length);
  for (const name of sortedNames) {
    if (key.includes(name)) return SWATCH_HEX[name];
  }

  return hashToSwatchColor(raw);
}

/**
 * Renders one pill/swatch group per product option and keeps the selection
 * pointing at a real variant. Shared by the quick-view modal and product page.
 */
function mountVariantPicker({ root, options, variants, onChange }) {
  if (!root) return;

  const firstAvailable =
    variants.find((variant) => variant.available !== false) || variants[0];
  let selected = firstAvailable ? [...firstAvailable.options] : [];

  function findVariant() {
    return variants.find(
      (variant) =>
        variant.options.length === selected.length &&
        variant.options.every((value, i) => normOptionValue(value) === normOptionValue(selected[i]))
    );
  }

  function valueIsAvailable(index, value) {
    const normalized = normOptionValue(value);
    return variants.some(
      (variant) =>
        normOptionValue(variant.options[index]) === normalized && variant.available !== false
    );
  }

  function sync() {
    let variant = findVariant();

    if (!variant || variant.available === false) {
      const repaired = variants.find((candidate) => candidate.available !== false);
      if (repaired) {
        selected = [...repaired.options];
        variant = repaired;
      }
    }

    root.querySelectorAll("[data-option-value]").forEach((button) => {
      const index = Number(button.dataset.optionIndex);
      const isSelected =
        normOptionValue(selected[index]) === normOptionValue(button.dataset.optionValue);
      button.classList.toggle("is-selected", isSelected);
      button.setAttribute("aria-checked", isSelected ? "true" : "false");
    });

    onChange?.(variant);
  }

  function choose(index, value) {
    selected[index] = normOptionValue(value);

    if (!findVariant()) {
      const normalized = normOptionValue(value);
      const fallback =
        variants.find(
          (variant) =>
            normOptionValue(variant.options[index]) === normalized && variant.available !== false
        ) ||
        variants.find((variant) => normOptionValue(variant.options[index]) === normalized);

      if (fallback) selected = [...fallback.options];
    }

    sync();
  }

  root.innerHTML = "";

  options.forEach((option, index) => {
    if (!shouldShowOption(option)) return;

    const fieldset = document.createElement("fieldset");
    fieldset.className = "product-option";

    const legend = document.createElement("legend");
    legend.className = "product-option__label";
    legend.textContent = option.name;
    fieldset.appendChild(legend);

    const asColor = isColorOption(option.name);
    const values = document.createElement("div");
    values.className = `product-option__values${asColor ? " product-option__values--color" : ""}`;
    values.setAttribute("role", "radiogroup");
    values.setAttribute("aria-label", option.name);

    sortOptionValues(option.name, option.values).forEach((value) => {
      const button = document.createElement("button");
      button.type = "button";
      button.className = asColor ? "product-option__swatch" : "product-option__size";
      button.dataset.optionIndex = String(index);
      button.dataset.optionValue = normOptionValue(value);
      button.setAttribute("role", "radio");
      button.setAttribute("aria-checked", "false");

      if (asColor) {
        button.style.setProperty("--swatch-color", swatchColor(value));
        button.setAttribute("aria-label", value);
        button.title = value;
      } else {
        button.textContent = value;
      }

      values.appendChild(button);
    });

    fieldset.appendChild(values);
    root.appendChild(fieldset);
  });

  root.onclick = (event) => {
    const button = event.target.closest("[data-option-value]");
    if (!button || !root.contains(button)) return;
    event.preventDefault();
    choose(Number(button.dataset.optionIndex), button.dataset.optionValue);
  };

  sync();
}

function updatePdpPrice(host, variant, fallbackPrice) {
  const priceEl = host.querySelector("[data-product-page-price]");
  const compareEl = host.querySelector("[data-product-page-compare]");
  const badgeEl = host.querySelector("[data-product-page-badge]");

  if (priceEl) priceEl.textContent = variant?.price || fallbackPrice;

  const discount = variant ? variantDiscountPercent(variant) : null;
  const onSale = Boolean(variant?.compare_at_price && discount);

  if (compareEl) {
    compareEl.hidden = !onSale;
    if (onSale) compareEl.textContent = variant.compare_at_price;
  }

  if (badgeEl) {
    badgeEl.hidden = !onSale;
    if (onSale) badgeEl.textContent = `${discount}% OFF`;
  }
}

/* —— Product page —— */
function isPdpMobileSlider() {
  return window.matchMedia("(max-width: 749px)").matches;
}

function setPdpGalleryIndex(host, index, { scroll = true } = {}) {
  const slides = [...host.querySelectorAll(".pdp__slide")];
  if (!slides.length) return;

  const safeIndex = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
  const activeSlide = slides[safeIndex];

  slides.forEach((slide, i) => {
    slide.classList.toggle("is-active", i === safeIndex);
    const img = slide.querySelector("img");
    if (!img) return;
    if (i === safeIndex) img.setAttribute("data-product-page-image", "");
    else img.removeAttribute("data-product-page-image");
  });

  host.querySelectorAll(".product-gallery__thumb").forEach((item) => {
    item.classList.toggle("is-active", String(item.dataset.galleryIndex) === String(safeIndex));
  });

  host.querySelectorAll(".pdp__dot").forEach((item) => {
    const match = String(item.dataset.galleryIndex) === String(safeIndex);
    item.classList.toggle("is-active", match);
    item.setAttribute("aria-selected", match ? "true" : "false");
  });

  const slider = host.querySelector("[data-pdp-slider]");
  if (scroll && slider && isPdpMobileSlider()) {
    slider.scrollTo({ left: safeIndex * slider.clientWidth, behavior: "smooth" });
  }
}

function initProductPage() {
  const host = document.querySelector("[data-product-page]");
  if (!host || host.dataset.ready === "true") return;
  host.dataset.ready = "true";

  const root = host.querySelector("#ProductPageVariants");
  const priceEl = host.querySelector("[data-product-page-price]");
  const variantInput = host.querySelector("[data-product-page-variant-id]");
  const submitBtn = host.querySelector(".product-form__submit");
  const submitLabel = submitBtn?.querySelector("span");
  const fallbackPrice = priceEl?.textContent || "";
  const slider = host.querySelector("[data-pdp-slider]");
  const galleryTriggers = [
    ...host.querySelectorAll(".product-gallery__thumb"),
    ...host.querySelectorAll(".pdp__dot"),
  ];

  const { options, variants } = readProductData(host);

  mountVariantPicker({
    root,
    options,
    variants,
    onChange(variant) {
      if (variantInput) variantInput.value = variant?.id ? String(variant.id) : "";
      updatePdpPrice(host, variant, fallbackPrice);
      if (variant?.image) {
        const match = galleryTriggers.find((item) => item.dataset.fullImage === variant.image);
        if (match) setPdpGalleryIndex(host, match.dataset.galleryIndex);
      }

      const missing = !variant;
      if (submitBtn) submitBtn.disabled = missing;
      if (submitLabel) submitLabel.textContent = missing ? "Unavailable" : "Add to cart";
    },
  });

  galleryTriggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      setPdpGalleryIndex(host, trigger.dataset.galleryIndex);
    });
  });

  if (slider) {
    let scrollTimer;
    slider.addEventListener("scroll", () => {
      if (!isPdpMobileSlider()) return;
      window.clearTimeout(scrollTimer);
      scrollTimer = window.setTimeout(() => {
        const index = Math.round(slider.scrollLeft / Math.max(slider.clientWidth, 1));
        setPdpGalleryIndex(host, index, { scroll: false });
      }, 60);
    }, { passive: true });
  }

  const quantityInput = host.querySelector("#ProductPageQuantity");
  host.querySelector(".quantity__button--minus")?.addEventListener("click", () => {
    if (quantityInput) {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
    }
  });
  host.querySelector(".quantity__button--plus")?.addEventListener("click", () => {
    if (quantityInput) {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
    }
  });

  host.querySelector(".product-page__form")?.addEventListener("submit", handleAddToCart);

  host.querySelectorAll("[data-open-accordion]").forEach((link) => {
    link.addEventListener("click", (event) => {
      const target = host.querySelector(link.getAttribute("data-open-accordion") || "");
      if (!(target instanceof HTMLDetailsElement)) return;
      event.preventDefault();
      target.open = true;
      target.scrollIntoView({ behavior: "smooth", block: "nearest" });
    });
  });
}

/* Single-variant catalog cards add straight to the cart; everything else opens
   the quick view so a size can be chosen first. */
function initCatalogForms() {
  document.querySelectorAll("form[data-catalog-add]").forEach((form) => {
    if (form.dataset.ready === "true") return;
    form.dataset.ready = "true";
    form.addEventListener("submit", handleAddToCart);
  });
}

function initProductQuickView() {
  const modal = document.getElementById("ProductModal");
  if (!modal || modal.dataset.ready === "true") return;
  modal.dataset.ready = "true";

  modal.querySelectorAll("[data-product-modal-close]").forEach((button) => {
    button.addEventListener("click", closeProductModal);
  });

  document.addEventListener("keydown", (event) => {
    if (!modal.hidden && event.key === "Escape") closeProductModal();
  });

  const quantityInput = modal.querySelector("#Quantity");

  modal.querySelector(".quantity__button--minus")?.addEventListener("click", () => {
    if (quantityInput) {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) - 1));
    }
  });

  modal.querySelector(".quantity__button--plus")?.addEventListener("click", () => {
    if (quantityInput) {
      quantityInput.value = String(Math.max(1, Number(quantityInput.value || 1) + 1));
    }
  });

  modal.querySelector(".product-form")?.addEventListener("submit", handleAddToCart);
}

/* —— Cart —— */

function isShopifyStorefront() {
  return document.body.dataset.shopifyTheme === "true";
}

function cartRoute(name, fallback) {
  return window.theme?.routes?.[name] || fallback;
}

function showFormMessage(form, text, isError) {
  const messageEl =
    form
      ?.closest("[data-product-page], .product-modal__info, .catalog-product")
      ?.querySelector("[data-form-message]") || document.getElementById("ProductModalMessage");

  if (!messageEl) return;

  messageEl.hidden = false;
  messageEl.textContent = text;
  messageEl.classList.toggle("is-error", Boolean(isError));
}

function setViewCartVisible(form, visible) {
  const viewCart =
    form?.querySelector("[data-view-cart]") ||
    form?.closest("[data-product-page], .product-modal__info")?.querySelector("[data-view-cart]");
  if (!viewCart) return;
  viewCart.hidden = !visible;
}

async function refreshCartCount() {
  const counters = document.querySelectorAll("[data-cart-count]");
  if (!counters.length) return;

  try {
    const response = await fetch(`${cartRoute("cart_url", "/cart")}.js`);
    if (!response.ok) return;
    const cart = await response.json();
    counters.forEach((el) => {
      el.textContent = cart.item_count;
    });
  } catch {
    /* leave the current count in place */
  }
}

/* Cart page: quantity edits go through the AJAX API, then the page re-renders. */
async function updateCartLineQuantity(input, quantity) {
  const line = Number(input?.dataset.line);
  if (!input || !line) return;

  const nextQty = Math.max(0, Number(quantity) || 0);
  input.value = String(nextQty);
  input.disabled = true;

  const lineRoot = input.closest(".cart-line");
  lineRoot?.querySelectorAll(".quantity__button").forEach((btn) => {
    btn.disabled = true;
  });

  try {
    const response = await fetch(`${cartRoute("cart_change_url", "/cart/change")}.js`, {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ line, quantity: nextQty }),
    });

    if (!response.ok) throw new Error("Cart update failed");
    window.location.reload();
  } catch (error) {
    console.error(error);
    input.disabled = false;
    lineRoot?.querySelectorAll(".quantity__button").forEach((btn) => {
      btn.disabled = false;
    });
  }
}

function initCartPage() {
  const cartRoot = document.querySelector("[data-cart-page]");
  if (!cartRoot || cartRoot.dataset.ready === "true") return;
  cartRoot.dataset.ready = "true";

  cartRoot.querySelectorAll("[data-cart-quantity]").forEach((input) => {
    input.addEventListener("change", () => {
      updateCartLineQuantity(input, input.value);
    });
  });

  cartRoot.querySelectorAll("[data-cart-qty-change]").forEach((button) => {
    button.addEventListener("click", () => {
      const input = button.closest(".quantity")?.querySelector("[data-cart-quantity]");
      if (!input) return;
      const delta = Number(button.dataset.cartQtyChange || 0);
      updateCartLineQuantity(input, Number(input.value || 0) + delta);
    });
  });
}

async function handleAddToCart(event) {
  event.preventDefault();

  const form = event.currentTarget;
  const submitBtn = form.querySelector(".product-form__submit");
  const label = submitBtn?.querySelector("span");
  const originalLabel = label?.textContent || "Add to cart";

  if (submitBtn) submitBtn.disabled = true;
  if (label) label.textContent = "Adding…";
  setViewCartVisible(form, false);

  try {
    if (!isShopifyStorefront()) {
      await new Promise((resolve) => window.setTimeout(resolve, 650));
      showFormMessage(form, "Added to cart.");
      setViewCartVisible(form, true);
      return;
    }

    const variantIdRaw = String(form.querySelector('[name="id"]')?.value || "").trim();
    const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value || 1));

    if (!/^\d+$/.test(variantIdRaw)) {
      showFormMessage(form, "Please select a size.", true);
      return;
    }

    const addUrl = cartRoute("cart_add_url", "/cart/add");
    const addJsUrl = addUrl.endsWith(".js") ? addUrl : `${addUrl}.js`;
    const payload = { items: [{ id: variantIdRaw, quantity }] };

    let response = await fetch(addJsUrl, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify(payload),
    });

    if (!response.ok && response.status >= 500) {
      const fallback = new FormData();
      fallback.append("id", variantIdRaw);
      fallback.append("quantity", String(quantity));
      response = await fetch(addJsUrl, {
        method: "POST",
        headers: { Accept: "application/json" },
        credentials: "same-origin",
        body: fallback,
      });
    }

    const data = await response.json();

    if (!response.ok) {
      const serverMsg = data.description || data.message || "";
      const soldOut = /sold out|out of stock|unavailable/i.test(serverMsg);
      showFormMessage(
        form,
        soldOut
          ? "This size is unavailable right now. Please try another size."
          : serverMsg || "This item could not be added.",
        true
      );
      return;
    }

    showFormMessage(form, "Added to cart.");
    setViewCartVisible(form, true);
    await refreshCartCount();
  } catch (error) {
    console.error("Add to cart failed:", error);
    showFormMessage(form, "Something went wrong. Please try again.", true);
  } finally {
    if (submitBtn) submitBtn.disabled = false;
    if (label) label.textContent = originalLabel;
  }
}

/* —— Modal open / close —— */

let lastModalTrigger = null;

function bindProductOpenTriggers() {
  document.querySelectorAll(".catalog-product__media").forEach((media) => {
    if (media.dataset.modalBound === "true") return;
    media.dataset.modalBound = "true";

    media.addEventListener("click", (event) => {
      if (event.target.closest("a")) return;
      event.preventDefault();
      openProductModal(media.closest(".catalog-product"));
    });
  });
}

function openProductModal(card) {
  try {
    openProductModalInner(card);
  } catch (error) {
    console.error("Product modal failed to open:", error);
  }
}

function openProductModalInner(card) {
  const modal = document.getElementById("ProductModal");
  if (!card || !modal) return false;

  lastModalTrigger = document.activeElement;

  const titleEl = document.getElementById("ProductModalTitle");
  const collectionEl = document.getElementById("ProductModalCollection");
  const priceEl = document.getElementById("ProductModalPrice");
  const descriptionEl = document.getElementById("ProductModalDescription");
  const variantsRoot = document.getElementById("ProductModalVariants");
  const detailsLink = document.getElementById("ProductModalDetailsLink");
  const variantInput = document.getElementById("ProductModalVariantId");
  const quantityInput = document.getElementById("Quantity");
  const messageEl = document.getElementById("ProductModalMessage");
  const submitBtn = modal.querySelector(".product-form__submit");

  const title = card.dataset.productTitle || "";
  const fallbackPrice = card.dataset.productPrice || "";
  const image = card.dataset.productImage || "";
  const description = card.dataset.productDescription || "";
  const collection = card.dataset.productCollection || "";
  const productUrl = card.dataset.productUrl || "#";

  const { options, variants, images } = readProductData(card);

  setModalImages({
    primary: images?.primary || image,
    secondary: images?.secondary || null,
    alt: title,
  });
  if (titleEl) titleEl.textContent = title;
  if (collectionEl) collectionEl.textContent = collection;
  if (descriptionEl) descriptionEl.textContent = description;
  if (detailsLink) detailsLink.href = productUrl;
  if (quantityInput) quantityInput.value = "1";
  if (messageEl) {
    messageEl.hidden = true;
    messageEl.textContent = "";
    messageEl.classList.remove("is-error");
  }
  setViewCartVisible(modal.querySelector(".product-form"), false);
  if (submitBtn) {
    const label = submitBtn.querySelector("span");
    if (label) label.textContent = "Add to cart";
    submitBtn.disabled = false;
  }

  mountVariantPicker({
    root: variantsRoot,
    options,
    variants,
    onChange(variant) {
      if (variantInput) variantInput.value = variant?.id ? String(variant.id) : "";
      renderModalPrice(priceEl, variant, fallbackPrice);
      setModalImages({
        primary: images?.primary || image,
        secondary: images?.secondary || null,
        alt: title,
        variantImage: variant?.image || null,
      });

      const missing = !variant;
      if (submitBtn) {
        submitBtn.disabled = missing;
        const label = submitBtn.querySelector("span");
        if (label) label.textContent = missing ? "Unavailable" : "Add to cart";
      }
    },
  });

  modal.classList.add("is-open");
  modal.removeAttribute("hidden");
  modal.hidden = false;
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add("is-modal-open");
  modal.querySelector(".product-modal__close")?.focus();
  return true;
}

function closeProductModal() {
  const modal = document.getElementById("ProductModal");
  if (!modal) return;

  modal.classList.remove("is-open");
  modal.hidden = true;
  modal.setAttribute("hidden", "");
  modal.setAttribute("aria-hidden", "true");
  document.body.classList.remove("is-modal-open");
  lastModalTrigger?.focus();
}

window.openProductModal = openProductModal;
window.closeProductModal = closeProductModal;

if (!window.__torrisCartInline) {
  document.addEventListener(
    "click",
    (event) => {
      const openTrigger = event.target.closest("[data-product-open]");
      if (!openTrigger) return;

      event.preventDefault();
      event.stopPropagation();
      openProductModal(openTrigger.closest(".product-card, .catalog-product"));
    },
    true
  );
}
